/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

/*
    Main 'Add to cart' (ATC) form
*/
window.onSubmitAtcForm = async (form, event) => {
    event.preventDefault()

    const btn = form.querySelector('.btn-atc')

    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    form.classList.add('loading')

    const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })

    form.classList.remove('loading')
    btn.innerHTML = window.theme.product.addedToCart

    setTimeout(() => {
        btn.innerHTML = btn.dataset.textAddToCart
    }, 2000)

    window.refreshCartContents(response)

    if (form.hasAttribute('data-ecomify-upsell-modal')) return
    if (btn.closest('.modal')) return

    if (document.querySelector('#offcanvas-cart')) {
        bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
    }
}

/*
    'Add to cart' form based on variant
*/
window.onClickAtcFormVariant = async (btn, event) => {
    const form = btn.closest('form')
    form.querySelector('[name="id"]').value = btn.dataset.variantId

    window.onSubmitAtcForm(form, event)
}

/*
    Product options selector - Listen for change events
*/
const updateProductOption = async (input) => {
    const selectedOptions = []

    input.closest('form').querySelectorAll('.product-option').forEach(elem => {
        if (elem.type === 'radio') {
            if (elem.checked) {
                selectedOptions.push(elem.value)
            }
        } else {
            selectedOptions.push(elem.value)
        }
    })

    const selectedVariant = window.productVariants.find(variant =>
        JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
    )

    console.log(selectedVariant)

    const btn = input.closest('form').querySelector('.btn-atc')

    if (selectedVariant) {
        input.closest('form').querySelector('[name="id"]').value = selectedVariant.id

        if (selectedVariant.available) {
            btn.disabled = false
            btn.innerHTML = window.theme.product.addToCart
        } else {
            btn.disabled = true
            btn.innerHTML = window.theme.product.soldOut
        }

        if (selectedVariant.compare_at_price) {
            input.closest('.product-content').querySelector('.product-price').innerHTML = `
                <span class="product-price-compare text-muted me-3">
                    <span class="visually-hidden">
                        ${window.theme.product.priceFrom} &nbsp;
                    </span>
                    <s>
                        ${Shopify.formatMoney(selectedVariant.compare_at_price)}
                    </s>
                </span>
                <span class="product-price-final">
                    <span class="visually-hidden">
                        ${window.theme.product.priceSale} &nbsp;
                    </span>
                    ${Shopify.formatMoney(selectedVariant.price)}
                </span>
            `
        } else {
            input.closest('.product-content').querySelector('.product-price').innerHTML = `
                <span class="product-price-final">
                    ${Shopify.formatMoney(selectedVariant.price)}
                </span>
            `
        }
        if (selectedVariant.available && selectedVariant.compare_at_price) {
            input.closest('.product-content').querySelector('.product-price').insertAdjacentHTML('beforeend', `
                <span class="price-badge-sale badge">
                    ${window.theme.product.save}: ${Math.round((1 - (selectedVariant.price / selectedVariant.compare_at_price)) * 100)}%
                </span>    
            `)
        } else if (!selectedVariant.available) {
            input.closest('.product-content').querySelector('.product-price').insertAdjacentHTML('beforeend', `
                <span class="price-badge-sold-out badge">
                    ${window.theme.product.soldOut}
                </span>
            `)
        }

        const purchaseOptionsWrapper = document.querySelector('#product-purchase-options')

        if (purchaseOptionsWrapper) {
            purchaseOptionsWrapper.querySelector('input#purchase-options-one-time + label [data-price]').textContent = Shopify.formatMoney(selectedVariant.price)
            purchaseOptionsWrapper.querySelector('input#purchase-options-subscription + label [data-price]').textContent = Shopify.formatMoney(selectedVariant.selling_plan_allocations[0].price)
        }

        const skuWrapper = input.closest('.product-content').querySelector('.current-variant-sku')

        if (skuWrapper) {
            if (selectedVariant.sku.length) {
                skuWrapper.textContent = selectedVariant.sku
                skuWrapper.removeAttribute('hidden')
            } else {
                skuWrapper.setAttribute('hidden', 'hidden')
            }
        }

        if (input.closest('#product-template')) {
            const url = new URL(window.location)
            url.searchParams.set('variant', selectedVariant.id)
            window.history.replaceState({}, '', url)
        }

        const customEvent = new CustomEvent('variantChange.ecomify.product', {
            detail: selectedVariant
        })
        window.dispatchEvent(customEvent)
    } else {
        btn.disabled = true
        btn.innerHTML = window.theme.product.unavailable
    }

    if (input.closest('.color-swatches')) {
        input.closest('.product-option-wrapper').querySelector('.color-swatches-title span')
            .textContent = input.dataset.displayValue || input.value
    }

    if (input.closest('.size-buttons')) {
        input.closest('.product-option-wrapper').querySelector('.size-buttons-title span')
            .textContent = input.value
    }
}

window.onChangeProductOption = async (input) => {
    const transition = window.spotPageTransition?.show()
    try {
        await updateProductOption(input)
    } finally {
        window.spotPageTransition?.hide(transition)
    }
}

/*
    Update various elements on variant change that need a new document fetch
*/
window.addEventListener('variantChange.ecomify.product', async (event) => {
    const inventoryBar = document.querySelector('#inventory-bar')

    if (inventoryBar) {
        inventoryBar.style.opacity = '.25'
    }

    const respoonse = await fetch(window.location.href)
    const text = await respoonse.text()
    const newDocument = new DOMParser().parseFromString(text, 'text/html')

    document.querySelector('#inventory-bar')
        ?.replaceWith(newDocument.querySelector('#inventory-bar'))
    document.querySelector('#product-qty-breaks')
        ?.replaceWith(newDocument.querySelector('#product-qty-breaks'))

    document.querySelector('#product-store-availability-wrapper')
        ?.replaceWith(newDocument.querySelector('#product-store-availability-wrapper'))

    initInventoryBar()
    initQtyBreaks()
})

/*
    Purchase options (selling/subscription plans)
*/
const initPurchaseOptions = () => {
    const wrapper = document.querySelector('#product-purchase-options')

    if (!wrapper) return

    wrapper.querySelectorAll('[name="purchase_option"]').forEach(input => {
        input.addEventListener('change', () => {
            if (input.id === 'purchase-options-one-time') {
                wrapper.querySelector('#purchase-delivery-options').setAttribute('hidden', 'hidden')
                wrapper.querySelector('[name="selling_plan"]').disabled = true
            } else {
                wrapper.querySelector('#purchase-delivery-options').removeAttribute('hidden')
                wrapper.querySelector('[name="selling_plan"]').disabled = false
            }
        })
    })
}
initPurchaseOptions()

// Product Item - Handle variant change
window.onChangeProductItemVariant = (select, event) => {
    if (select.options[select.selectedIndex].dataset.variantImage?.length) {
        select.closest('.product-item').querySelector('.product-item-img').src =
            select.options[select.selectedIndex].dataset.variantImage
    }

    const compareAtPrice = select.options[select.selectedIndex].dataset.compareAtPrice
    const price = select.options[select.selectedIndex].dataset.price

    if (compareAtPrice.length) {
        select.closest('.product-item').querySelector('.product-item-price').innerHTML = `
            <span class="product-item-price-compare text-muted me-1">
                <span class="visually-hidden">
                    ${window.theme.product.priceFrom} &nbsp;
                </span>
                <s>
                    ${Shopify.formatMoney(compareAtPrice)}
                </s>
            </span>
            <span class="product-item-price-final">
                <span class="visually-hidden">
                    ${window.theme.product.priceSale} &nbsp;
                </span>
                ${Shopify.formatMoney(price)}
            </span>
        `
    } else {
        select.closest('.product-item').querySelector('.product-item-price').innerHTML = `
            <span class="product-item-price-final">
                ${Shopify.formatMoney(price)}
            </span>
        `
    }
}

/*
    'Buy it now' button
*/
window.onClickBuyBtn = (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
    const form = btn.closest('form')
    const variantId = form.querySelector('[name="id"]').value
    const qty = Number(form.querySelector('input[name="quantity"]')?.value || 1)
    window.location.href = `/cart/${variantId}:${qty}`
}

/*
    Product Gallery
*/
const initProductGallery = () => {
    document.querySelectorAll('.product-gallery:not(.init)').forEach(gallery => {
        gallery.classList.add('init')

        const main = new Splide(gallery.querySelector('.main-splide'), {
            start: Number(gallery.dataset.start),
            rewind: true,
            arrows: false,
            drag: document.querySelector('.main-splide .splide__list')?.children.length > 1,
            dragMinThreshold: { mouse: 0, touch: 5 },
            rewindByDrag: true,
            pagination: false,
            noDrag: 'model-viewer',
            mediaQuery: 'min',
            breakpoints: {
                0: { padding: { right: gallery.dataset.showThumbsMobile === 'false' ? '4rem' : 0 } },
                992: { padding: 0 }
            },
            direction: document.documentElement.getAttribute('dir') || 'ltr'
        })

        const totalSlides = gallery.querySelectorAll('.main-splide .splide__slide').length

        const thumbs = new Splide(gallery.querySelector('.thumbs-splide'), {
            start: Number(gallery.dataset.start),
            gap: '.5rem',
            rewind: true,
            rewindByDrag: true,
            pagination: false,
            isNavigation: true,
            focus: totalSlides > 5 ? 'center' : 0,
            mediaQuery: 'min',
            breakpoints: {
                0: { perPage: 5, arrows: true },
                576: { perPage: 5, arrows: true },
                768: { perPage: 5, arrows: true },
                992: { perPage: 5, arrows: true },
                1200: { perPage: 5, arrows: true },
                1400: { perPage: 5, arrows: true }
            },
            direction: document.documentElement.getAttribute('dir') || 'ltr'
        })

        main.on('move', (newIndex, prevIndex) => {
            const iframe = gallery.querySelector(`.splide__slide:nth-child(${prevIndex + 1}) iframe`)
            const video = gallery.querySelector(`.splide__slide:nth-child(${prevIndex + 1}) video`)
            if (iframe) {
                // eslint-disable-next-line no-self-assign
                iframe.src = iframe.src
            }
            if (video) {
                video.pause()
            }
        })

        window.addEventListener('variantChange.ecomify.product', (event) => {
            const selectedVariant = event.detail

            if (selectedVariant.featured_media) {
                main.go(selectedVariant.featured_media.position - 1)
            }
        }, false)

        main.sync(thumbs)
        main.mount()
        thumbs.mount()

        if (window.matchMedia('(min-width: 992px)').matches) {
            const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0
            const announcementBarHeight = document.querySelector('[id*="__announcement-bar"].sticky-top')?.clientHeight || 0
            gallery.style.position = 'sticky'
            gallery.style.top = `${navbarHeight + announcementBarHeight + 20}px`
            gallery.style.zIndex = '1'
        }

        if (window.GLightbox) {
            // eslint-disable-next-line no-unused-vars
            const lightbox = GLightbox({
                selector: `[data-gallery="product-gallery-${gallery.dataset.productId}"]`,
                videosWidth: '1290px',
                loop: true
            })
            lightbox.on('slide_changed', ({ prev, current }) => {
                main.go(current.index)
            })
        }

        const modelViewer = gallery.querySelector('model-viewer')

        if (modelViewer) {
            const increaseBtn = gallery.querySelector('[data-model-3d-increase-zoom]')
            const decreaseBtn = gallery.querySelector('[data-model-3d-decrease-zoom]')
            const fullscreenBtn = gallery.querySelector('[data-model-3d-fullscreen]')

            increaseBtn.addEventListener('click', () => {
                modelViewer.zoom(1)
            })

            decreaseBtn.addEventListener('click', () => {
                modelViewer.zoom(-1)
            })

            fullscreenBtn.addEventListener('click', () => {
                if (document.fullscreenElement) {
                    document.exitFullscreen()
                    fullscreenBtn.querySelector('.bi-fullscreen').removeAttribute('hidden')
                    fullscreenBtn.querySelector('.bi-fullscreen-exit').setAttribute('hidden', 'hidden')
                } else {
                    modelViewer.closest('.product-gallery-model-3d').requestFullscreen()
                    fullscreenBtn.querySelector('.bi-fullscreen').setAttribute('hidden', 'hidden')
                    fullscreenBtn.querySelector('.bi-fullscreen-exit').removeAttribute('hidden')
                }
            })
        }
    })
}
initProductGallery()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.product-gallery')) {
        initProductGallery()
    }
})

window.addEventListener('updated.ecomify.collection', initProductGallery)

/*
    Inventory Bar
*/
const initInventoryBar = () => {
    const wrapper = document.querySelector('#inventory-bar')

    if (!wrapper) return

    const progressBar = wrapper.querySelector('.progress-bar')

    setTimeout(() => {
        progressBar.style.width = progressBar.dataset.width
    }, 250)
}
initInventoryBar()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('#inventory-bar')) {
        initInventoryBar()
    }
})

/*
    Upsell modal
*/
const initUpsellModal = () => {
    const modal = document.querySelector('#product-upsell-modal')
    if (!modal) return

    const form = document.querySelector('#product-content form[onsubmit*="onSubmitAtcForm"]')
    if (!form) return

    form.setAttribute('data-ecomify-upsell-modal', 'true')

    form.addEventListener('submit', (e) => {
        const modal = bootstrap.Modal.getOrCreateInstance('#product-upsell-modal')
        modal.show()
    })

    document.querySelectorAll('#product-upsell-modal .btn-atc').forEach(btn => {
        btn.addEventListener('click', () => {
            const footerBtn = document.querySelector('#product-upsell-modal .modal-footer .btn')
            footerBtn.classList.remove(footerBtn.dataset.defaultClass)
            footerBtn.classList.add(footerBtn.dataset.activeClass)
        })
    })

    modal.addEventListener('hidden.bs.modal', () => {
        const offcanvasCart = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart')
        offcanvasCart.show()
    })
}
initUpsellModal()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('#product-upsell-modal')) {
        initUpsellModal()
    }
})

/*
    Bought Together
*/
const initBoughtTogether = () => {
    const root = document.querySelector('#product-bought-together')
    if (!root) return

    const atcBtn = root.querySelector('#bought-together-atc')
    const totalElem = root.querySelector('#bought-together-total')

    // El theme setea Shopify.money_format = "${{amount_no_decimals}}" y formatMoney separa
    // los miles con coma, pero el servidor rendera CLP con punto ($37.980, no $37,980).
    // El separador real sale de una cifra de prueba que rendereó Liquid.
    const moneySep = (String(totalElem.dataset.moneyProbe || '').match(/\d(\D)\d{3}/) || [null, ','])[1]
    const money = cents => Shopify.formatMoney(cents).replace(/,/g, moneySep)

    const setTotalPrice = () => {
        let totalCompareAtPrice = 0
        let totalPrice = 0

        root.querySelectorAll('.product-item-price').forEach(elem => {
            if (elem.closest('.product-item').querySelector('.bought-together-check:checked')) {
                totalCompareAtPrice += elem.dataset.compareAtPrice.length ? Number(elem.dataset.compareAtPrice) : Number(elem.dataset.price)
                totalPrice += Number(elem.dataset.price)
            }
        })

        const label = `<span class="spot-bt__total-label">${totalElem.dataset.textTotalPrice}</span>`

        if (totalCompareAtPrice > totalPrice) {
            totalElem.innerHTML = `
                ${label}
                <span class="spot-bt__total-values">
                    <span class="spot-bt__total-compare">
                        <span class="visually-hidden">
                            ${window.theme.product.priceFrom} &nbsp;
                        </span>
                        <s>${money(totalCompareAtPrice)}</s>
                    </span>
                    <span class="spot-bt__total-final">
                        <span class="visually-hidden">
                            ${window.theme.product.priceSale} &nbsp;
                        </span>
                        ${money(totalPrice)}
                    </span>
                    <span class="spot-bt__savings">
                        ${totalElem.dataset.textSavings} ${money(totalCompareAtPrice - totalPrice)}
                    </span>
                </span>
            `
        } else {
            totalElem.innerHTML = `
                ${label}
                <span class="spot-bt__total-values">
                    <span class="spot-bt__total-final">${money(totalPrice)}</span>
                </span>
            `
        }
    }

    root.querySelectorAll('.bought-together-check').forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
            // Antes: checkbox.closest('.product-item').style.opacity = '.5'. Mismo efecto,
            // pero por clase para que el apagado lo defina el CSS junto al resto del skin.
            checkbox.closest('.product-item').classList.toggle('is-off', !checkbox.checked)

            atcBtn.disabled = !root.querySelector('.bought-together-check:checked')

            setTotalPrice()
        })
    })

    root.querySelectorAll('select[name="id"]').forEach(select => {
        select.addEventListener('change', () => {
            const compareAtPrice = select.options[select.selectedIndex].dataset.compareAtPrice
            const price = select.options[select.selectedIndex].dataset.price

            select.closest('.product-item').querySelector('.product-item-price')
                .setAttribute('data-compare-at-price', compareAtPrice)
            select.closest('.product-item').querySelector('.product-item-price')
                .setAttribute('data-price', price)

            setTotalPrice()
        })
    })

    atcBtn.addEventListener('click', async (e) => {
        const btn = e.currentTarget

        btn.style.width = btn.clientWidth + 4 + 'px'
        btn.innerHTML = `
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        `

        const items = []

        root.querySelectorAll('.product-item').forEach(elem => {
            if (elem.querySelector('.bought-together-check:checked')) {
                items.push({
                    id: Number(elem.querySelector('[name="id"]').value),
                    quantity: 1
                })
            }
        })

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
        })

        btn.innerHTML = window.theme.product.addedToCart

        setTimeout(() => {
            // El ancho fijo se limpia porque ahora el botón es full-width.
            btn.style.width = ''
            btn.innerHTML = btn.dataset.textAddToCart
        }, 2000)

        window.refreshCartContents(response)

        bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
    })
}
initBoughtTogether()

/*
    Qty Breaks
*/
const initQtyBreaks = () => {
    document.querySelectorAll('[name="product-qty-breaks"]').forEach(radio => {
        radio.addEventListener('change', () => {
            const qty = Number(radio.dataset.qty)

            const qtyField = radio.closest('form').querySelector('[name="quantity"]')
            const btn = radio.closest('form').querySelector('button[name="add"]')

            if (!qtyField) return

            qtyField.value = qty

            setTimeout(() => {
                btn.classList.add('animate__animated', 'animate__shakeX')
            }, 250)

            setTimeout(() => {
                btn.classList.remove('animate__animated', 'animate__shakeX')
            }, 1500)
        })
    })
}
initQtyBreaks()

/*
    Prev/Next Products (will show only if the product is within a collection)
*/
const initPrevNextButtons = async () => {
    const wrapper = document.querySelector('#product-prev-next')

    if (!wrapper) return

    if (!window.matchMedia('(max-width: 1599px)').matches) return

    await new Promise(resolve => setTimeout(resolve, 1000))

    const threshold = document.querySelector('.product-content .form-wrapper').getBoundingClientRect().bottom + window.scrollY

    window.addEventListener('scroll', () => {
        if (window.scrollY > threshold) {
            wrapper.classList.add('show')
        } else {
            wrapper.classList.remove('show')
        }
    })
}
initPrevNextButtons()

/*
    Personalization (Custom properties)
*/
const initPersonalization = () => {
    document.querySelectorAll('.product-personalization-field[data-type="checkbox"]').forEach(elem => {
        let values = []

        elem.querySelectorAll('input').forEach(checkbox => {
            checkbox.addEventListener('change', () => {
                if (checkbox.checked) {
                    values.push(checkbox.value)
                } else {
                    values = values.filter((item) => item !== checkbox.value)
                }

                elem.querySelector('[type="hidden"]').value = values.join(', ')
            })
        })
    })
}
initPersonalization()

/*
    Limited Offer
*/
const initLimitedOffer = () => {
    const block = document.querySelector('#product-limited-offer')

    if (!block) return

    const icon = block.querySelector('.block-icon')

    setInterval(() => {
        icon.classList.add('animate__animated', 'animate__tada')

        setTimeout(() => {
            icon.classList.remove('animate__animated', 'animate__tada')
        }, 1500)
    }, 3000)
}
initLimitedOffer()

const spotSiblingSearchCache = new Map()
const spotProductDocumentCache = new Map()
const spotProductSectionsCache = new Map()
let spotProductNavigationController

const normalizeSpotSiblingValue = (value) => String(value || '').trim().toLocaleLowerCase('es-CL')

const getSpotProductDocument = (href) => {
    const targetUrl = new URL(href, window.location.origin)
    targetUrl.hash = ''
    const cacheKey = targetUrl.href

    if (!spotProductDocumentCache.has(cacheKey)) {
        const request = fetch(cacheKey, {
            headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
        }).then(async (response) => {
            if (!response.ok) throw new Error(`Product navigation failed: ${response.status}`)

            const html = await response.text()
            const productDocument = new DOMParser().parseFromString(html, 'text/html')
            if (!productDocument.querySelector('main #product-template')) {
                throw new Error('Product template missing')
            }

            return productDocument
        }).catch((error) => {
            spotProductDocumentCache.delete(cacheKey)
            throw error
        })

        spotProductDocumentCache.set(cacheKey, request)
    }

    return spotProductDocumentCache.get(cacheKey)
}

const getSpotDynamicSectionIds = (main) => Array.from(main.querySelectorAll('[id^="shopify-section-"]'))
    .filter((section) => !section.querySelector('qurate-slider'))
    .map((section) => section.id.replace(/^shopify-section-/, ''))
    .slice(0, 5)

const getSpotProductSections = (href, sectionIds) => {
    const targetUrl = new URL(href, window.location.origin)
    targetUrl.hash = ''
    targetUrl.searchParams.set('sections', sectionIds.join(','))
    const cacheKey = targetUrl.href

    if (!spotProductSectionsCache.has(cacheKey)) {
        const request = fetch(cacheKey, {
            // application/json selects raw product data instead of rendered sections.
            headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
        }).then(async (response) => {
            if (!response.ok) throw new Error(`Product sections failed: ${response.status}`)

            const sections = await response.json()
            const hasEverySection = sectionIds.every((sectionId) => typeof sections[sectionId] === 'string')
            if (!hasEverySection) throw new Error('Product sections missing')

            return sections
        }).catch((error) => {
            spotProductSectionsCache.delete(cacheKey)
            throw error
        })

        spotProductSectionsCache.set(cacheKey, request)
    }

    return spotProductSectionsCache.get(cacheKey)
}

const prefetchSpotSiblingSections = (selector) => {
    const main = document.querySelector('main')
    if (!main) return

    const sectionIds = getSpotDynamicSectionIds(main)
    const selectorRoot = selector.closest('.product-content') || selector
    const urls = Array.from(selectorRoot.querySelectorAll('[data-spot-sibling-link]'), (link) => link.href)
    let nextUrlIndex = 0

    const prefetchNext = async () => {
        while (nextUrlIndex < urls.length) {
            const url = urls[nextUrlIndex++]

            try {
                await getSpotProductSections(url, sectionIds)
            } catch (error) {
                // Navigation keeps its normal full-page fallback if a section prefetch fails.
            }
        }
    }

    Array.from({ length: Math.min(3, urls.length) }, () => prefetchNext())
}

const replaceSpotProductSections = (sections, sectionIds) => {
    const replacements = sectionIds.map((sectionId) => {
        const currentSection = document.querySelector(`#shopify-section-${CSS.escape(sectionId)}`)
        const sectionDocument = new DOMParser().parseFromString(sections[sectionId], 'text/html')
        const nextSection = sectionDocument.body.firstElementChild

        if (!currentSection || !nextSection) throw new Error('Product section replacement failed')

        return [currentSection, document.importNode(nextSection, true)]
    })

    replacements.forEach(([currentSection, nextSection]) => currentSection.replaceWith(nextSection))
}

const getSpotSiblingCandidates = async (selector) => {
    const productType = selector.dataset.spotCurrentType
    const searchUrl = new URL(selector.dataset.spotSearchUrl, window.location.origin)
    searchUrl.searchParams.set('view', 'spot-siblings')
    searchUrl.searchParams.set('type', 'product')
    searchUrl.searchParams.set('options[prefix]', 'none')
    searchUrl.searchParams.set('q', `product_type:${JSON.stringify(productType)}`)

    const cacheKey = searchUrl.toString()

    if (!spotSiblingSearchCache.has(cacheKey)) {
        const request = fetch(cacheKey, {
            headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
        }).then(async (response) => {
            if (!response.ok) throw new Error(`Sibling search failed: ${response.status}`)

            const html = await response.text()
            const searchDocument = new DOMParser().parseFromString(html, 'text/html')

            return Array.from(searchDocument.querySelectorAll('[data-spot-sibling-result]')).map((result) => ({
                aroma: result.dataset.spotAroma,
                available: result.dataset.spotAvailable === 'true',
                color: result.dataset.spotColor,
                format: result.dataset.spotFormat,
                handle: result.dataset.spotHandle,
                type: result.dataset.spotType,
                url: result.getAttribute('href'),
                variants: Array.from(result.querySelectorAll('[data-spot-sibling-variant]')).map((variant) => ({
                    available: variant.dataset.spotVariantAvailable === 'true',
                    color: variant.dataset.spotVariantColor,
                    id: variant.dataset.spotVariantId
                }))
            }))
        }).catch((error) => {
            spotSiblingSearchCache.delete(cacheKey)
            throw error
        })

        spotSiblingSearchCache.set(cacheKey, request)
    }

    return spotSiblingSearchCache.get(cacheKey)
}

const normalizeSpotColorValue = (value, handle = '') => {
    const normalizedHandle = normalizeSpotSiblingValue(handle)
    if (normalizedHandle.includes('black')) return 'negro'

    const normalized = normalizeSpotSiblingValue(value)
    if (normalized === 'ambar' || normalized === 'amber') return 'ambar'
    if (normalized === 'black' || normalized === 'negro') return 'negro'
    if (normalized === 'transparent' || normalized === 'transparente') return 'transparente'
    if (normalized === 'default title') return ''
    return normalized
}

const getSpotColorLabel = (color) => ({
    ambar: 'Ámbar',
    negro: 'Negro',
    transparente: 'Transparente'
})[color] || color

const getSpotColorValue = (color) => ({
    ambar: '#9a5f17',
    negro: '#2d2d2d',
    transparente: '#f0f0ee'
})[color] || '#d8d5cf'

const getSpotColorPriority = (color) => ({ ambar: 0, negro: 1, transparente: 2 })[color] ?? 10

const getSpotVariantUrl = (candidate, variant) => {
    const url = new URL(candidate.url, window.location.origin)
    if (variant?.id) url.searchParams.set('variant', variant.id)
    return `${url.pathname}${url.search}`
}

const getSpotAromaTarget = (candidates, preferredColor, current = {}) => {
    const choices = candidates.flatMap((candidate) => candidate.variants.map((variant) => ({
        available: variant.available,
        candidate,
        color: normalizeSpotColorValue(variant.color || candidate.color, candidate.handle),
        variant
    })))
    const currentChoice = choices.find((choice) =>
        choice.candidate.handle === current.handle && String(choice.variant.id) === String(current.variantId)
    )
    if (currentChoice) return currentChoice

    const availableChoices = choices.filter((choice) => choice.available)
    const preferredChoice = availableChoices.find((choice) => choice.color === preferredColor)
    if (preferredChoice) return preferredChoice

    return availableChoices.sort((a, b) => getSpotColorPriority(a.color) - getSpotColorPriority(b.color))[0]
        || choices[0]
}

const renderSpotColorSelector = (selector, candidates, current, currentColor) => {
    const colorSelector = selector.closest('.product-content')?.querySelector('[data-spot-color-selector]')
    if (!colorSelector) return

    const currentAroma = normalizeSpotSiblingValue(current.aroma)
    const colorOptions = new Map()

    candidates.forEach((candidate) => {
        if (normalizeSpotSiblingValue(candidate.aroma) !== currentAroma) return

        candidate.variants.forEach((variant) => {
            const color = normalizeSpotColorValue(variant.color || candidate.color, candidate.handle)
            if (!color) return

            const option = {
                available: variant.available,
                candidate,
                color,
                rawColor: variant.color || candidate.color,
                url: getSpotVariantUrl(candidate, variant),
                variant
            }
            const existing = colorOptions.get(color)
            const isExactCurrent = candidate.handle === current.handle
                && String(variant.id) === String(current.variantId)

            if (!existing || isExactCurrent || (!existing.available && option.available)) {
                colorOptions.set(color, option)
            }
        })
    })

    const options = Array.from(colorOptions.values()).sort((a, b) =>
        getSpotColorPriority(a.color) - getSpotColorPriority(b.color)
    )
    if (options.length <= 1) {
        colorSelector.hidden = true
        return
    }

    const optionsWrapper = colorSelector.querySelector('[data-spot-color-options]')
    const fragment = document.createDocumentFragment()
    let selectedLabel = getSpotColorLabel(currentColor)

    options.forEach((option) => {
        const isCurrent = option.candidate.handle === current.handle
            && String(option.variant.id) === String(current.variantId)
        let control

        if (!option.available || isCurrent || option.candidate.handle === current.handle) {
            control = document.createElement('button')
            control.type = 'button'
            if (!option.available) control.disabled = true
            if (option.available && !isCurrent) {
                control.dataset.spotLocalColor = option.rawColor
                control.dataset.spotVariantId = option.variant.id
            }
        } else {
            control = document.createElement('a')
            control.href = option.url
            control.dataset.spotSiblingLink = 'true'
            control.dataset.spotColorOption = 'true'
        }

        const label = getSpotColorLabel(option.color)
        control.className = 'spot-color-selector__swatch'
        control.dataset.spotColorLabel = label
        control.style.setProperty('--spot-color-swatch', getSpotColorValue(option.color))
        control.title = option.available ? label : `${label} · Agotado`
        control.setAttribute('aria-label', control.title)

        if (isCurrent) {
            control.classList.add('is-current')
            control.setAttribute('aria-pressed', 'true')
            selectedLabel = label
        } else if (!option.available) {
            control.setAttribute('aria-disabled', 'true')
        }

        fragment.appendChild(control)
    })

    optionsWrapper.replaceChildren(fragment)
    colorSelector.querySelector('[data-spot-color-value]').textContent = selectedLabel
    colorSelector.hidden = false
}

const renderSpotSiblingSelector = async (selector, options = {}) => {
    if (selector.dataset.spotInitialized === 'true' && !options.force) return
    selector.dataset.spotInitialized = 'true'

    const current = {
        aroma: selector.dataset.spotCurrentAroma,
        color: selector.dataset.spotCurrentColor,
        format: selector.dataset.spotCurrentFormat,
        handle: selector.dataset.spotCurrentHandle,
        type: selector.dataset.spotCurrentType,
        url: selector.dataset.spotCurrentUrl,
        variantId: selector.dataset.spotCurrentVariantId
    }
    const candidates = await getSpotSiblingCandidates(selector)
    const candidatesByAroma = new Map()

    candidates.forEach((candidate) => {
        if (normalizeSpotSiblingValue(candidate.type) !== normalizeSpotSiblingValue(current.type)) return
        if (normalizeSpotSiblingValue(candidate.format) !== normalizeSpotSiblingValue(current.format)) return

        const aromaKey = normalizeSpotSiblingValue(candidate.aroma)
        if (!aromaKey) return

        if (!candidatesByAroma.has(aromaKey)) candidatesByAroma.set(aromaKey, [])
        candidatesByAroma.get(aromaKey).push(candidate)
    })

    if (!candidatesByAroma.size) return

    const currentAromaKey = normalizeSpotSiblingValue(current.aroma)
    const currentCandidates = candidatesByAroma.get(currentAromaKey) || []
    const currentCandidate = currentCandidates.find((candidate) => candidate.handle === current.handle)
    const currentVariant = currentCandidate?.variants.find((variant) =>
        String(variant.id) === String(current.variantId)
    )
    const currentColor = normalizeSpotColorValue(
        currentVariant?.color || current.color || currentCandidate?.color,
        current.handle
    )

    const optionsWrapper = selector.querySelector('[data-spot-aroma-options]')
    const fragment = document.createDocumentFragment()
    const aromaOptions = Array.from(candidatesByAroma.entries()).map(([aromaKey, aromaCandidates]) => ({
        aroma: aromaCandidates[0].aroma,
        aromaKey,
        target: getSpotAromaTarget(aromaCandidates, currentColor, {
            handle: aromaKey === currentAromaKey ? current.handle : '',
            variantId: aromaKey === currentAromaKey ? current.variantId : ''
        })
    })).sort((a, b) =>
        a.aroma.localeCompare(b.aroma, 'es', { sensitivity: 'base' })
    )

    aromaOptions.forEach((option) => {
        const link = document.createElement('a')
        link.className = 'spot-aroma-selector__option'
        link.href = option.target ? getSpotVariantUrl(option.target.candidate, option.target.variant) : '#'
        link.textContent = option.aroma

        if (option.aromaKey === currentAromaKey) {
            link.classList.add('is-current')
            link.setAttribute('aria-current', 'page')
        } else if (option.target?.available) {
            link.dataset.spotSiblingLink = 'true'
        } else {
            link.classList.add('is-unavailable')
            link.setAttribute('aria-disabled', 'true')
            link.tabIndex = -1
        }

        fragment.appendChild(link)
    })

    optionsWrapper.replaceChildren(fragment)
    selector.hidden = false
    renderSpotColorSelector(selector, candidates, current, currentColor)
    prefetchSpotSiblingSections(selector)
}

const initSpotSiblingSelectors = (scope = document) => {
    scope.querySelectorAll('[data-spot-aroma-selector]').forEach((selector) => {
        renderSpotSiblingSelector(selector).catch(() => {
            selector.hidden = true
        })
    })
}

const fireSpotSiblingProductView = (scope = document) => {
    const payloadNode = scope.querySelector('[data-spot-product-view]')
    if (!payloadNode || payloadNode.dataset.spotTracked === 'true') return

    payloadNode.dataset.spotTracked = 'true'

    let payload
    try {
        payload = JSON.parse(payloadNode.textContent)
    } catch (error) {
        return
    }

    if (window.SpotItemCache) {
        window.SpotItemCache.set(payload.cache.variantId, payload.cache.item)
    }
    if (typeof window.gtag === 'function') {
        window.gtag('event', 'view_item', payload.ga4)
    }
    if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'ViewContentSpot', payload.meta)
    }
}

const syncSpotProductHead = (nextDocument) => {
    document.title = nextDocument.title

    const attributes = [
        ['link[rel="canonical"]', 'href'],
        ['meta[name="description"]', 'content'],
        ['meta[property="og:title"]', 'content'],
        ['meta[property="og:description"]', 'content'],
        ['meta[property="og:url"]', 'content'],
        ['meta[property="og:image"]', 'content'],
        ['meta[name="twitter:title"]', 'content'],
        ['meta[name="twitter:description"]', 'content'],
        ['meta[name="twitter:image"]', 'content']
    ]

    attributes.forEach(([selector, attribute]) => {
        const current = document.querySelector(selector)
        const next = nextDocument.querySelector(selector)
        if (current && next) current.setAttribute(attribute, next.getAttribute(attribute))
    })
}

const reinitializeSpotProductMain = () => {
    document.querySelectorAll('main .shopify-section').forEach((section) => {
        section.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }))
    })

    initPurchaseOptions()
    initBoughtTogether()
    initQtyBreaks()
    initPersonalization()
    const productVariantsNode = document.querySelector('[data-spot-product-variants]')
    if (productVariantsNode) {
        try {
            window.productVariants = JSON.parse(productVariantsNode.textContent)
        } catch (error) {
            console.error('[Spot sibling selector] Product variants failed to sync', error)
        }
    }
    initSpotSiblingSelectors()

    if (window.Shopify?.PaymentButton) {
        window.Shopify.PaymentButton.init()
    }

    window.dispatchEvent(new Event('resize'))
}

const navigateSpotSiblingProduct = async (href, options = {}) => {
    const targetUrl = new URL(href, window.location.origin)
    const currentMain = document.querySelector('main')
    if (!currentMain || targetUrl.origin !== window.location.origin) {
        window.location.assign(targetUrl.href)
        return
    }

    spotProductNavigationController?.abort()
    const navigationController = new AbortController()
    spotProductNavigationController = navigationController
    let transition
    document.documentElement.classList.add('spot-product-navigation-loading')
    currentMain.setAttribute('aria-busy', 'true')

    try {
        let nextDocument

        try {
            const sectionIds = getSpotDynamicSectionIds(currentMain)
            if (!sectionIds.length) throw new Error('Product sections unavailable')

            const request = getSpotProductSections(targetUrl.href, sectionIds)
            transition = window.spotPageTransition?.show(request)
            const sections = await request
            await transition?.covered
            if (navigationController.signal.aborted) return

            replaceSpotProductSections(sections, sectionIds)
        } catch (sectionError) {
            if (navigationController.signal.aborted) return

            const request = getSpotProductDocument(targetUrl.href)
            transition = window.spotPageTransition?.show(request)
            nextDocument = await request
            await transition?.covered
            if (navigationController.signal.aborted) return

            const nextMain = nextDocument.querySelector('main')
            if (!nextMain) throw sectionError

            syncSpotProductHead(nextDocument)
            const nextNodes = Array.from(nextMain.childNodes).map((node) => document.importNode(node, true))
            currentMain.replaceChildren(...nextNodes)
        }

        if (options.pushHistory !== false) {
            window.history.pushState({ spotSiblingProduct: true }, '', `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`)
        }

        try {
            reinitializeSpotProductMain()
        } catch (error) {
            console.error('[Spot sibling selector] Product reinitialization failed', error)
        }

        try {
            fireSpotSiblingProductView()
        } catch (error) {
            console.error('[Spot sibling selector] Product tracking failed', error)
        }

        if (!nextDocument) {
            getSpotProductDocument(targetUrl.href).then((headDocument) => {
                const currentUrl = new URL(window.location.href)
                if (currentUrl.pathname === targetUrl.pathname && currentUrl.search === targetUrl.search) {
                    syncSpotProductHead(headDocument)
                }
            }).catch(() => {})
        }

        if (options.focusCurrent !== false) {
            try {
                document.querySelector('[data-spot-aroma-selector] [aria-current="page"]')?.focus({ preventScroll: true })
            } catch (error) {
                console.error('[Spot sibling selector] Product focus failed', error)
            }
        }
    } catch (error) {
        if (navigationController.signal.aborted || error.name === 'AbortError') return

        if (options.pushHistory === false) {
            window.location.reload()
        } else {
            window.location.assign(targetUrl.href)
        }
    } finally {
        if (spotProductNavigationController === navigationController) {
            spotProductNavigationController = undefined
            document.documentElement.classList.remove('spot-product-navigation-loading')
            document.querySelector('main')?.removeAttribute('aria-busy')
            window.spotPageTransition?.hide(transition)
        }
    }
}

const setSpotSiblingPendingState = (link) => {
    const colorSelector = link.closest('[data-spot-color-selector]')
    if (colorSelector) {
        colorSelector.querySelector('.spot-color-selector__swatch.is-current')?.classList.remove('is-current')
        link.classList.add('is-current')
        colorSelector.querySelector('[data-spot-color-value]').textContent = link.dataset.spotColorLabel
        colorSelector.setAttribute('aria-busy', 'true')
        return
    }

    const selector = link.closest('[data-spot-aroma-selector]')
    if (!selector) return

    const currentLink = selector.querySelector('.spot-aroma-selector__option.is-current')
    if (currentLink && currentLink !== link) {
        currentLink.classList.remove('is-current')
        currentLink.removeAttribute('aria-current')
        currentLink.dataset.spotSiblingLink = 'true'
    }

    link.classList.add('is-current')
    link.setAttribute('aria-current', 'page')
    link.removeAttribute('data-spot-sibling-link')
      selector.querySelector('strong')?.replaceChildren(link.textContent.trim())
    selector.setAttribute('aria-busy', 'true')
}

document.addEventListener('click', async (event) => {
    const colorOption = event.target.closest('[data-spot-local-color]')
    if (!colorOption || event.defaultPrevented) return

    const productContent = colorOption.closest('.product-content')
    const nativeColorOption = productContent?.querySelector('[data-spot-color-native]')
    const aromaSelector = productContent?.querySelector('[data-spot-aroma-selector]')
    if (!nativeColorOption || !aromaSelector) return

    nativeColorOption.value = colorOption.dataset.spotLocalColor
    await window.onChangeProductOption(nativeColorOption)

    aromaSelector.dataset.spotCurrentColor = colorOption.dataset.spotLocalColor
    aromaSelector.dataset.spotCurrentVariantId = colorOption.dataset.spotVariantId
    renderSpotSiblingSelector(aromaSelector, { force: true }).catch(() => {})
})

document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-spot-sibling-link]')
    if (!link || event.defaultPrevented || event.button !== 0) return
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    event.preventDefault()
    const href = link.href
    setSpotSiblingPendingState(link)
    navigateSpotSiblingProduct(href)
})

window.addEventListener('popstate', () => {
    if (!window.location.pathname.startsWith('/products/')) return
    if (!document.querySelector('#product-template')) return

    navigateSpotSiblingProduct(window.location.href, {
        pushHistory: false,
        focusCurrent: false
    })
})

initSpotSiblingSelectors()
